module.exports = __webpack_public_path__ + "img/camera_power.d34fe1aa.png";